import { Box, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import FormTemplateManagement from "./FormTemplateManagement";
import FormTemplateWorkFlow from "./FormTemplateWorkFlow";
import { useTranslation } from "react-i18next";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      style={{width: '100%', height: '100%'}}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component={'span'}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const FormTemplate: React.FC = () => {
  const { t } = useTranslation(['translation']);
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: '100%'}}
    >
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        sx={{ borderRight: 1, borderColor: 'divider' }}
      >
        <Tab label={t('formTemplate.formTemplates')} {...a11yProps(0)} />
        <Tab label={t('formTemplate.workflows')} {...a11yProps(1)} />
      </Tabs>
      <TabPanel value={value} index={0}>
        <FormTemplateManagement></FormTemplateManagement>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <FormTemplateWorkFlow></FormTemplateWorkFlow>
      </TabPanel>
    </Box>
  );
};

export default FormTemplate;
